import React from 'react'
import * as  C from "../componentsM/index"

const Mathematics = () => {
    return (
        <>

            <C.Hero title={"GROUP 5: MATHEMATICS"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The nature of mathematics can be summarised in a number of ways: for example, it can be seen as a well-defined body of knowledge, as an abstract system of ideas, or as a useful tool. For many people it is probably a combination of these, but there is no doubt that mathematical knowledge provides an important key to understanding the world in which we live.</p>


                    <p>Subjects currently offered:</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Mathematics HL:</h1>

                    <p>This course caters for students with a good background in mathematics who are competent in a range of analytical and technical skills. The majority of these students will be expecting to include mathematics as a major component of their university studies, either as a subject in its own right or within courses such as physics, engineering and technology. Others may take this subject because they have a strong interest in mathematics and enjoy meeting its challenges and engaging with its problems.</p>


                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Mathematics SL:</h1>

                    <p>This course caters for students who already possess knowledge of basic mathematical concepts, and who
                        are equipped with the skills needed to apply simple mathematical techniques correctly. The majority of
                        these students will expect to need a sound mathematical background as they prepare for future studies in
                        subjects such as chemistry, economics, psychology and business administration.</p>


        
                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Mathematical studies SL:</h1>


                    <p>This course is equivalent in status to mathematics SL, but addresses different needs. It has an emphasis on applications of mathematics, and the largest section is on statistical techniques. It is designed for students with varied mathematical backgrounds and abilities.  It prepares students to be able to solve problems in a variety of settings, to develop more sophisticated mathematical reasoning and to enhance their critical thinking. Students taking this course are well prepared for a career in social sciences, humanities, languages or arts. This course is only available at the SL level.

                    </p>




                </div>
            </section>

        </>

    )
}

export default Mathematics